import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';

const AvailableHoursWrapper = styled.section`
  .hours-list {
    padding: 0;

    .hours-list-item {
      list-style-type: none;
      border-radius: 50px;
      padding: 8px;
      margin-bottom: 12px;
      background-color: ${mainColors.main_color_rgba(0.4)};
      &:hover {
        cursor: pointer;
        background-color: ${mainColors.main_color_rgba(0.8)};
      }

      .hours-list-item-text {
        text-align: center;
        font-family: Verdana, sans-serif;
      }
    }

    .selected-item {
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;

      &:hover {
        cursor: default;
        background: transparent;
      }

      .hours-list-item-text {
        padding: 8px 16px;
        border-radius: 50px;

        &:hover {
          cursor: pointer;
          background-color: ${mainColors.main_color_rgba(0.8)};
        }
      }

      .single-option {
        &:hover {
          cursor: default;
          background-color: inherit;
        }
      }
    }
  }
`;

export default AvailableHoursWrapper;
